/** Accepts only paths on this site; anything else falls back to the start page. */
export const safeRedirect = (redirectTo?: string) =>
  redirectTo?.startsWith("/") &&
  !redirectTo.startsWith("//") &&
  !redirectTo.startsWith("/\\")
    ? redirectTo
    : undefined;

let entering = false;

/**
 * Loads the app anew so the freshly established session is picked up. Runs once:
 * a code login also fires SIGNED_IN.
 */
export const enterApp = (redirectTo?: string) => {
  if (entering) return;
  entering = true;
  const target = safeRedirect(redirectTo);
  if (target) {
    // Return to a hash route (e.g. the OAuth consent page).
    window.location.href = `/#${target}`;
    window.location.reload();
  } else {
    window.location.href = "/";
  }
};
